/**
 * Check if the input query string is possibly a technical PLZ
 *
 * @param query input query string
 * @returns
 */
export const isTechPlz = (query: string) => query?.length === 6 && !isNaN(parseInt(query, 10));
